export default __webpack_public_path__ + "static/media/cockpit.40249400.svg";